/**
 * Self-host mode detection.
 *
 * Zibby's cloud React app can be built + served by the SELF-HOSTED control
 * plane (localhost:13001 style), where auth is a project/operator PAT instead
 * of the SaaS session cookie and the SaaS-only surfaces (pricing, billing,
 * public marketplace, OAuth callbacks, …) don't exist. Everything self-host
 * specific branches on this single predicate so the CLOUD path stays
 * byte-identical when the flag is off.
 *
 * Two independent switches, either one flips it on:
 *   1. build-time  REACT_APP_SELF_HOST === 'true'   (baked into the bundle)
 *   2. runtime     window.__ZIBBY_SELF_HOST__ === true
 *      (injected by the control-plane's SPA HTML — lets one generic build
 *       serve both, and gives a browser escape hatch)
 */
export function isSelfHost() {
  return (
    process.env.REACT_APP_SELF_HOST === 'true' ||
    (typeof window !== 'undefined' && window.__ZIBBY_SELF_HOST__ === true)
  );
}

// localStorage key the self-host build reads/writes the operator PAT under.
// The control-plane injects window.__ZIBBY_BOOT_TOKEN__ for verified-local
// requests (auto-login); a remote operator pastes a PAT which we persist here.
export const SELFHOST_PAT_KEY = 'zibby_selfhost_pat';

export default isSelfHost;
